import { useEffect, useState } from "react";
import { CadUploadConfigUnit } from "@iventis/domain-model/model/cadUploadConfigUnit";
import { useSubjectContext } from "../subjects-context";

export function useUnitsSelected() {
    const { unitsSelected$ } = useSubjectContext();
    const [units, setUnits] = useState(unitsSelected$.value);

    useEffect(() => {
        const sub = unitsSelected$.subscribe((updatedUnits) => {
            setUnits(updatedUnits);
        });

        return () => {
            sub.unsubscribe();
        };
    }, [unitsSelected$]);

    return {
        units,
        setUnits: (value: CadUploadConfigUnit | null) => {
            unitsSelected$.next(value);
        },
    };
}
